import React, { useEffect, useState } from "react";

import { Button, Switch, Input, Space, InputNumber, Table } from "antd";
import { Collapse } from "antd";
import GitInfo from "react-git-info/macro";
import MateriiSettings from "../../Components/Materii/MateriiSettings";
import ModalAni from "./ModalAni";
import Condica from "../../Pages/Profesori/Condica";
import { useSelector } from "react-redux";
import { signOut } from "firebase/auth";
import { auth } from "../../database/firebase";
import { useRef } from "react";
import ModalSettingsModule from "./ModalSettingsModule";
import { useReactToPrint } from "react-to-print";
import { updateDocDatabase } from "../../database";
const { Panel } = Collapse;

function Settings() {
  const [show, setShow] = useState(false);
  const clase = useSelector((state) => state.clase);
  const [localPermissions, setLocalPermissions] = useState({});
  const [savingPermissions, setSavingPermissions] = useState(false);

  // Funcție helper pentru a obține valoarea curentă (local sau din Redux)
  const getCurrentValue = (classId, field, defaultValue) => {
    return (
      localPermissions[classId]?.[field] ??
      clase.find((c) => c.id === classId)?.permisiuni?.[field] ??
      defaultValue
    );
  };
  const dates = [
    new Date("2023-09-01"),
    new Date("2023-10-01"),
    new Date("2023-11-01"),
    new Date("2023-12-01"),
    new Date("2024-01-01"),
    new Date("2024-02-01"),
    new Date("2024-03-01"),
    new Date("2024-04-01"),
    new Date("2024-05-01"),
    new Date("2024-06-01"),
    new Date("2024-07-01"),
    new Date("2024-08-01"),
    new Date("2024-09-01"),
  ];
  const [showModule, setShowModule] = useState(false);
  const [open, setOpen] = useState(false);
  const profesori = useSelector((state) => state.profesori);
  const gitInfo = GitInfo();
  const [date, setDate] = useState(dates[0]);
  const [activeIndex, setActiveIndex] = useState();
  const [showPurtare, setShowPurtare] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const componentRef = useRef();
  const settings = useSelector((state) => state.settings);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const saveAllPermissions = async () => {
    setSavingPermissions(true);
    try {
      // Actualizează array-ul de clase cu permisiunile modificate
      const updatedClase = clase.map((clasa) => {
        if (localPermissions[clasa.id]) {
          return {
            ...clasa,
            permisiuni: {
              ...clasa?.permisiuni,
              ...localPermissions[clasa.id],
            }
          };
        }
        return clasa;
      });

      // Salvează în colecția "clase" cu documentul "clase"
      await updateDocDatabase("clase", "clase", {
        clase: updatedClase
      });

      // Resetează state-ul local după salvare
      setLocalPermissions({});

      console.log("Permisiunile au fost salvate cu succes!");
    } catch (error) {
      console.error("Eroare la salvarea permisiunilor:", error);
    } finally {
      setSavingPermissions(false);
    }
  };

  const Print = () => {
    return (
      <div ref={componentRef}>
        {[...profesori]
          .sort((a, b) => {
            return (a?.numeDeFamilie + a.prenume)?.localeCompare(
              b?.numeDeFamilie + b.prenume,
              "ro"
            );
          })
          .map((p) => {
            return (
              <div style={{ textAlign: "center", pageBreakAfter: "always" }}>
                <br />
                <br />
                <h1>{p.numeDeFamilie + " " + p.prenume}</h1>
                <Condica profesorData={p} dateDefault={date} print={true} />
              </div>
            );
          })}
      </div>
    );
  };
  return (
    <div
      style={{
        display: "block",
        alignItems: "center",
        alignContent: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      {/* <div style={{ display: "none" }}>
        <Print />
      </div> */}
      <MateriiSettings
        setOpen={setShow}
        open={show}
        confirmLoading={confirmLoading}
        setConfirmLoading={setConfirmLoading}
      />
      <ModalAni setIsModalOpen={setOpen} open={open} />

      <h2> Setări Platforma</h2>
      <br />
      <br />
      <Collapse
        styled
        style={{
          width: "80%",
          marginLeft: "10%",
          marginRight: "10px",
          paddingRight: "10px",
        }}
        onChange={(key) => {
          setActiveIndex(key);
        }}
      >
        <Panel key="1" header="Resurse">
          {" "}
          <div
            style={{
              display: "flex",
              flexDirection: "grow",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <br />
            <Button
              style={{
                backgroundColor: "yellow",
                color: "black",
              }}
              onClick={() => {
                setShow(true);
              }}
            >
              Setări Materii
            </Button>
            <Button
              style={{
                backgroundColor: "yellow",
                color: "black",
              }}
              onClick={() => {
                setOpen(true);
              }}
            >
              Setări Ani
            </Button>

            <br />
            <br />
            <Switch
              checkedChildren="Profesorii au acces la purtare"
              unCheckedChildren="Profesorii nu au acces la purtare"
              checked={settings?.showPurtare || false}
              onChange={async (e) => {
                await updateDocDatabase("settings", "settings", {
                  showPurtare: e,
                });
              }}
            />
            <br />
            <br />

            <br />
            <br />
            <Switch
              checkedChildren="Restrictia de 3 saptamani dezactivata"
              unCheckedChildren="Restrictia de 3 saptamani activata"
              checked={settings?.treiSapt || false}
              onChange={async (e) => {
                await updateDocDatabase("settings", "settings", {
                  treiSapt: e,
                });
              }}
            />

            <br />
            <br />
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                  }}
                >
                  Template înștiințări obișnuite:
                </label>
                <Input
                  placeholder="./instiintare parinti 2025 completat.docx"
                  value={settings?.instiintare || ""}
                  onChange={async (e) => {
                    await updateDocDatabase("settings", "settings", {
                      instiintare: e.target.value,
                    });
                  }}
                  style={{ width: "100%" }}
                />
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                  }}
                >
                  Template înștiințări corigent:
                </label>
                <Input
                  placeholder="./instiintare parinti corigenti completat.docx"
                  value={settings?.instiintareCorigent || ""}
                  onChange={async (e) => {
                    await updateDocDatabase("settings", "settings", {
                      instiintareCorigent: e.target.value,
                    });
                  }}
                  style={{ width: "100%" }}
                />
              </div>
            </Space>

            {/* <Button
              style={{
                backgroundColor: "yellow",
                color: "black",
                width: "11.5vw",
              }}
              onClick={() => {
                setShowModule(true);
              }}
            >
              Setari Module
            </Button> */}
            <br />
          </div>
        </Panel>
      </Collapse>

      <Collapse
        styled
        style={{
          width: "80%",
          marginLeft: "10%",
          marginRight: "10px",
          paddingRight: "10px",
        }}
      >
        <Panel key="3" header="Permisiuni">
          <Table
            dataSource={[...clase]
              .sort((a, b) => {
                // Function to get numeric value for sorting (same as in Clase.jsx)
                const getClassOrder = (anClasa) => {
                  const grade = anClasa?.toLowerCase();
                  switch (grade) {
                    case "pregătitoare":
                      return 0;
                    case "i":
                      return 1;
                    case "ii":
                      return 2;
                    case "iii":
                      return 3;
                    case "iv":
                      return 4;
                    case "v":
                      return 5;
                    case "vi":
                      return 6;
                    case "vii":
                      return 7;
                    case "viii":
                      return 8;
                    case "ix":
                      return 9;
                    case "x":
                      return 10;
                    case "xi":
                      return 11;
                    case "xii":
                      return 12;
                    case "xiii":
                      return 13;
                    // Adaugă clase de liceu/universitate cu "Anul"
                    case "anul i":
                      return 14;
                    case "anul ii":
                      return 15;
                    case "anul iii":
                      return 16;
                    case "anul iv":
                      return 17;
                    case "anul v":
                      return 18;
                    default:
                      return 999; // Unknown grades go to end
                  }
                };

                const orderA = getClassOrder(a?.anClasa);
                const orderB = getClassOrder(b?.anClasa);

                // First sort by grade order
                if (orderA !== orderB) {
                  return orderA - orderB;
                }

                // If same grade, sort by identifier (A, B, C, etc.)
                const identifierA = a?.identificator || "";
                const identifierB = b?.identificator || "";
                return identifierA.localeCompare(identifierB);
              })
              .map((clasa) => ({
                key: clasa.id,
                clasa: `${clasa.anClasa} ${clasa.identificator}`,
                ...clasa,
              }))}
            columns={[
              {
                title: "Clasa",
                dataIndex: "clasa",
                key: "clasa",
                fixed: "left",
                width: 150,
              },
              {
                title: (
                  <div>
                    <div>Note - Zile retroactive</div>
                    <div
                      style={{
                        fontSize: "11px",
                        fontWeight: "normal",
                        color: "#666",
                      }}
                    >
                      Câte zile în urmă pot profesorii
                      <br />
                      să adauge note (default: 21)
                    </div>
                  </div>
                ),
                dataIndex: "zileInapoiNote",
                key: "zileInapoiNote",
                width: 180,
                render: (_, record) => (
                  <InputNumber
                    min={0}
                    max={365}
                    value={getCurrentValue(record.id, "zileInapoiNote", 21)}
                    onChange={(value) => {
                      setLocalPermissions((prev) => ({
                        ...prev,
                        [record.id]: {
                          ...prev[record.id],
                          zileInapoiNote: value,
                        },
                      }));
                    }}
                    style={{ width: "80px" }}
                  />
                ),
              },
              {
                title: (
                  <div>
                    <div>Absențe - Zile retroactive</div>
                    <div
                      style={{
                        fontSize: "11px",
                        fontWeight: "normal",
                        color: "#666",
                      }}
                    >
                      Câte zile în urmă pot profesorii
                      <br />
                      să marcheze absențe (default: 21)
                    </div>
                  </div>
                ),
                dataIndex: "zileInapoiAbsente",
                key: "zileInapoiAbsente",
                width: 180,
                render: (_, record) => (
                  <InputNumber
                    min={0}
                    max={365}
                    value={getCurrentValue(record.id, "zileInapoiAbsente", 21)}
                    onChange={(value) => {
                      setLocalPermissions((prev) => ({
                        ...prev,
                        [record.id]: {
                          ...prev[record.id],
                          zileInapoiAbsente: value,
                        },
                      }));
                    }}
                    style={{ width: "80px" }}
                  />
                ),
              },
              {
                title: (
                  <div>
                    <div>Scutiri medicale - Zile retroactive</div>
                    <div
                      style={{
                        fontSize: "11px",
                        fontWeight: "normal",
                        color: "#666",
                      }}
                    >
                      Câte zile în urmă pot fi adăugate
                      <br />
                      scutiri și motivări (default: 30)
                    </div>
                  </div>
                ),
                dataIndex: "zileInapoiScutiri",
                key: "zileInapoiScutiri",
                width: 180,
                render: (_, record) => (
                  <InputNumber
                    min={0}
                    max={365}
                    value={getCurrentValue(record.id, "zileInapoiScutiri", 30)}
                    onChange={(value) => {
                      setLocalPermissions((prev) => ({
                        ...prev,
                        [record.id]: {
                          ...prev[record.id],
                          zileInapoiScutiri: value,
                        },
                      }));
                    }}
                    style={{ width: "80px" }}
                  />
                ),
              },
              {
                title: (
                  <div>
                    <div>Acces diriginte extins</div>
                    <div
                      style={{
                        fontSize: "11px",
                        fontWeight: "normal",
                        color: "#666",
                      }}
                    >
                      Permite dirigintelui să adauge
                      <br />
                      note la TOATE materiile clasei
                      <br />
                      <em>
                        Util pentru elevi transferați - introducere situație
                        școlară
                      </em>
                    </div>
                  </div>
                ),
                dataIndex: "diriginteToateNotele",
                key: "diriginteToateNotele",
                width: 180,
                render: (_, record) => (
                  <Switch
                    checked={getCurrentValue(
                      record.id,
                      "diriginteToateNotele",
                      false
                    )}
                    onChange={(checked) => {
                      setLocalPermissions((prev) => ({
                        ...prev,
                        [record.id]: {
                          ...prev[record.id],
                          diriginteToateNotele: checked,
                        },
                      }));
                    }}
                  />
                ),
              },
            ]}
            scroll={{ x: 800 }}
            pagination={false}
          />
          <div style={{ marginTop: "16px", textAlign: "center" }}>
            <Button
              type="primary"
              size="large"
              loading={savingPermissions}
              onClick={saveAllPermissions}
              disabled={Object.keys(localPermissions).length === 0}
              style={{
                backgroundColor:
                  Object.keys(localPermissions).length > 0
                    ? "#52c41a"
                    : undefined,
                borderColor:
                  Object.keys(localPermissions).length > 0
                    ? "#52c41a"
                    : undefined,
              }}
            >
              {savingPermissions
                ? "Se salvează..."
                : `Salvează permisiunile${
                    Object.keys(localPermissions).length > 0
                      ? ` (${
                          Object.keys(localPermissions).length
                        } clase modificate)`
                      : ""
                  }`}
            </Button>
          </div>
        </Panel>
      </Collapse>
      <Collapse
        styled
        style={{
          width: "80%",
          marginLeft: "10%",
          marginRight: "10px",
          paddingRight: "10px",
        }}
      >
        <Panel key="2" header="Despre">
          <div style={{ fontWeight: "bold" }}>
            Versiune : 2.0
            <br />
            Ultima actualizare platforma:{" "}
            {new Date(gitInfo?.commit?.date).toLocaleDateString("ro-RO")}
            <br />
            Mesaj de actualizare: {gitInfo.commit.message}
            <br />
            <br />
            PFA Dobricean Ioan Dorian
            <br />
            0747934436 <br />
            dobriceanionut@dobriceansoftware.com
            <br />
            dobriceanionut1408@gmail.com
          </div>
        </Panel>
      </Collapse>

      <Collapse
        styled
        style={{
          width: "80%",
          marginLeft: "10%",
          marginRight: "10px",
          paddingRight: "10px",
        }}
      >
        {/* <Panel key="2" header="Condica">
          <div style={{ fontWeight: "bold" }}>
            <Button
              style={{
                backgroundColor: "yellow",
                color: "black",
              }}
              onClick={() => {
                setDate(dates[0]);
                if (date.toDateString() == dates[0].toDateString())
                  handlePrint();
              }}
            >
              Export Condica Septembrie
            </Button>
            <br />
            <br />
            <Button
              style={{
                backgroundColor: "yellow",
                color: "black",
              }}
              onClick={() => {
                setDate(dates[1]);
                if (date.toDateString() == dates[1].toDateString())
                  handlePrint();
              }}
            >
              Export Condica Octombrie
            </Button>
            <br />
            <br />
            <Button
              style={{
                backgroundColor: "yellow",
                color: "black",
              }}
              onClick={() => {
                setDate(dates[2]);
                if (date.toDateString() == dates[2].toDateString())
                  handlePrint();
              }}
            >
              Export Condica Noiembrie
            </Button>
            <br />
            <br />
            <Button
              style={{
                backgroundColor: "yellow",
                color: "black",
              }}
              onClick={() => {
                setDate(dates[3]);
                if (date.toDateString() == dates[3].toDateString())
                  handlePrint();
              }}
            >
              Export Condica Decembrie
            </Button>
            <br />
            <br />
            <Button
              style={{
                backgroundColor: "yellow",
                color: "black",
              }}
              onClick={() => {
                setDate(dates[4]);
                if (date.toDateString() == dates[4].toDateString())
                  handlePrint();
              }}
            >
              Export Condica Ianuarie
            </Button>
            <br />
            <br />
            <Button
              style={{
                backgroundColor: "yellow",
                color: "black",
              }}
              onClick={() => {
                setDate(dates[5]);
                if (date.toDateString() == dates[5].toDateString())
                  handlePrint();
              }}
            >
              Export Condica Februarie
            </Button>
            <br />
            <br />
            <Button
              style={{
                backgroundColor: "yellow",
                color: "black",
              }}
              onClick={() => {
                setDate(dates[6]);
                if (date.toDateString() == dates[6].toDateString())
                  handlePrint();
              }}
            >
              Export Condica Martie
            </Button>
            <br />
            <br />
            <Button
              style={{
                backgroundColor: "yellow",
                color: "black",
              }}
              onClick={() => {
                setDate(dates[7]);
                if (date.toDateString() == dates[7].toDateString())
                  handlePrint();
              }}
            >
              Export Condica Aprile
            </Button>
            <br />
            <br />
            <Button
              style={{
                backgroundColor: "yellow",
                color: "black",
              }}
              onClick={() => {
                setDate(dates[8]);
                if (date.toDateString() == dates[8].toDateString())
                  handlePrint();
              }}
            >
              Export Condica Mai
            </Button>

            <br />
            <br />
            <Button
              style={{
                backgroundColor: "yellow",
                color: "black",
              }}
              onClick={() => {
                setDate(dates[9]);

                if (date.toDateString() === dates[9].toDateString())
                  handlePrint();
              }}
            >
              Export Condica Iunie
            </Button>
             <br />
            <br />
            <Button
              style={{
                backgroundColor: "yellow",
                color: "black",
              }}
              onClick={() => {
                setDate(dates[10]);

                if (date.toDateString() === dates[10].toDateString())
                  handlePrint();
              }}
            >
              Export Condica Iulie
            </Button>
             <br />
            <br />
            <Button
              style={{
                backgroundColor: "yellow",
                color: "black",
              }}
              onClick={() => {
                setDate(dates[11]);

                if (date.toDateString() === dates[11].toDateString())
                  handlePrint();
              }}
            >
              Export Condica August
            </Button>
          </div>
        </Panel> */}
      </Collapse>
      <br />
      <br />
      <Button
        style={{ backgroundColor: "red", color: "white", fontWeight: "bold" }}
        onClick={() => {
          signOut(auth);
        }}
      >
        Iesi din cont
      </Button>
      <br />
    </div>
  );
}

export default Settings;
